"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "torrita-di-siena": {
    "f9383f89": [{
      "hkey": "5d5f2104",
      "slug": "torrita-di-siena",
      "name": "Torrita di Siena",
      "primary": true,
      "skipSearch": false
    }],
    "capannone": [{
      "hkey": "5d5f2104",
      "slug": "torrita-di-siena",
      "name": "Torrita di Siena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3dcf6967": [{
      "hkey": "5d5f2104",
      "slug": "torrita-di-siena",
      "name": "Torrita di Siena",
      "primary": true,
      "skipSearch": false
    }],
    "ciliano": [{
      "hkey": "5d5f2104",
      "slug": "torrita-di-siena",
      "name": "Torrita di Siena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "98687fba": [{
      "hkey": "1cffeafb",
      "slug": "caselle-gore-guardavalle",
      "name": "Caselle-Gore-Guardavalle",
      "primary": true,
      "skipSearch": false
    }],
    "guardavalle": [{
      "hkey": "1cffeafb",
      "slug": "caselle-gore-guardavalle",
      "name": "Caselle-Gore-Guardavalle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f8a672b5": [{
      "hkey": "c28732af",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "torrita": [{
      "hkey": "c28732af",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;